const References = () => {
  // Reference logos from the provided image
  const references = [
    { id: 1, name: 'Yaşar', logo: 'logo-yasar-holding.png' },
    { id: 2, name: 'KapGel', logo: 'kapgel1.png' },
    { id: 3, name: 'Superlit Boru', logo: 'superlitboru.png' },
    { id: 4, name: 'Orta Anadolu Ticaret Sanayi', logo: 'ortaanadoluticsan.png' },
    { id: 5, name: 'Karel Elektronik', logo: 'karelelektroniksanvetic.png' },
    { id: 6, name: 'Karamancı Holding', logo: 'karamanciholdingas.png' },
    { id: 7, name: 'Karel Elektrik', logo: 'karelelektrikuretimas.png' },
    { id: 8, name: 'BÜN Teknopark', logo: 'bunteknoparkas.jpg' },
  ];

  return (
    <section id="referanslar" className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">Referanslarımız</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Yılların deneyimiyle hizmet verdiğimiz bazı değerli kurumlar
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-6 px-4">
          {references.map((ref) => (
            <div 
              key={ref.id}
              className="bg-white p-6 rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300 h-40 flex items-center justify-center transform hover:scale-[1.03] hover:shadow-blue-200/60 border border-gray-100"
            >
              <img 
                src={`/images/references/${ref.logo}`}
                alt={ref.name}
                className="max-h-16 max-w-full object-contain"
                onError={(e) => {
                  const target = e.target as HTMLImageElement;
                  target.src = `https://via.placeholder.com/200x80?text=${ref.name}`;
                  target.className = 'max-h-16 max-w-full object-contain opacity-70';
                }}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default References;
